import type { TermType, Term } from "@onestore/api/types"

export function getTermsByType(type: TermType, terms: Term[]): Term["id"][] {
  return terms
    .filter((term) => term.checked && term.type === type)
    .map((term) => term.id)
}
